import { createEvent, createStore } from 'effector';
import { Curso } from '../../models/usuario.model';

export const atualizaListaCurso = createEvent<Curso[]>();

export const $listaCurso = createStore<Curso[]>([]).on(atualizaListaCurso, (_, cursos) => cursos);
